// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","button__select":"Button_button__select__HzHRv","button__primary":"Button_button__primary__aHiDx"};